import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';


import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

import {store} from './state/store';
import { Provider } from 'react-redux'

import {
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";
import ProtectedRoute from './components//ProtectedRoute';
import LoginModal from './Login';
import { ContentWrapper } from './components/ContentWrapper';
import { Notifications } from './components/notifications/Notifications';
import Checkout from './components/payments/Checkout';
import CheckoutComplete from './components/payments/CheckoutComplete';
import UserProfile from './components/account/UserProfile';
import ProductListing from './components/products/ProductListing';
import ProductDetail from './components/products/ProductDetail';
import { ThemeProvider } from '@mui/material';
import { darkTheme } from './theme';
import ProductEditor from './components/products/ProductEditor';
import MyCreationsList from './components/products/MyCreationsListing';

declare global {
  interface Window {
    firebase: any;
    auth: any;
  }
}

const router = createBrowserRouter([
  {
    path: "/",
    element: <ProtectedRoute><App /></ProtectedRoute>,
    children: [
      {
        path: '/library',
        element: <>Library</>,
      },
      {
        path: '/subscriptions',
        element: <>Subscriptions</>,
      },
      {
        path: '/creations',
        element: <MyCreationsList/>,
      },
      {
        path: '/creations/:productId/edit',
        element: <ProductEditor isEdit={true} />,
      },
      {
        path: '/product',
        element: <ProductListing />,
      },
      {
        path: '/product/create',
        element: <ProductEditor />,
      },
      {
        path: "/product/:productId",
        element: <ProductDetail/>,
      },
      {
        path: "/profile",
        element: <ProtectedRoute><UserProfile/></ProtectedRoute>,
      },
      {
        path: "/checkout/:productId",
        element: <ProtectedRoute><Checkout/></ProtectedRoute>,
      },
      {
        path: "/checkout/complete",
        element: <ProtectedRoute><CheckoutComplete/></ProtectedRoute>,
      },
    ]
  },
  {
    path: "/login",
    element: <LoginModal open={true}/>,
  },
]);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
  <Provider store={store}>
  <ThemeProvider theme={darkTheme}>
  <ContentWrapper>
  <RouterProvider router={router} />
  <Notifications/>
  </ContentWrapper>
  </ThemeProvider>
  </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
